const zh = {
	tipsTitle: '提示：以下为标签来源信息，仅供参考：',
	projectManager: '项目经理',
	labelOwner: '标签拥有者',
};

export default zh;
